import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';


@Injectable({
  providedIn: 'root'
})
export class ViewGrievanceService {

  constructor(public httpClient: HttpClient) { }

  //load grievance history by grievance id rest
  async loadGrievanceHistoryById(id) {
    const data = { complaintId: id };
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadSelfGrievanceHistory, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //reply grievance to support rest
  async replyGrievance(data) {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.replyFromMhadaUser, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  //download attachment rest
  async downloadAttachment(ghDocument) {
    const data = {
      'documentPath': ghDocument
    }
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.downloadFileForGrievance, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //update close grievance
  async closeGrievance(grievanceId) {
    const data = {
      'complaintId': grievanceId,
    }
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.close, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //reopen grievance
  async reopenGrievance(grievanceId) {
    const data = {
      'complaintId': grievanceId,
    }
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.reopen, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

}
